import React from 'react';
import { useIntl } from 'react-intl';
import { useLocation } from 'react-router-dom';
import {
    ColumnLayout,
    FormField,
    Input,
    FormSection,
    Checkbox,
} from '@amzn/awsui-components-react';

import { useProvider } from 'data/ProviderContext';
import { messages } from '../ClassForm.messages';
import { LOCATION_SOURCES, handleFormValueChange } from '../ClassForm.utils';
import { FieldErrors } from '../FieldErrors';
import '../ClassForm.css';

const AdvancedSettings = ({
    setClassData,
    learningActivityID,
    source,
    fieldsInvalid,
    handleFormSubmit,
}) => {
    const { formatMessage } = useIntl();
    const { search } = useLocation();
    const [checked, setChecked] = React.useState(source === LOCATION_SOURCES.LADS);
    const isDirectProvider = useProvider()?.type === 'DIRECT';
    const queryParams = new URLSearchParams(search);
    const isAdvancedMode = queryParams.get('mode') === 'advanced';

    const handleKeyboardSubmit = e => {
        if (e.detail.key === 'Enter') handleFormSubmit(e);
    };

    const valueFormatter = (code, values) => {
        if (code === 'LearningActivityMismatch') {
            return values
                .map(val => {
                    switch (val) {
                        case 'classCapacity':
                            return 'Number of students';
                        case 'course':
                            return 'Course';
                        case 'instructors':
                            return 'Instructors';
                        case 'virtualUrl':
                            return 'Virtual classroom URL';
                        default:
                            return val;
                    }
                })
                .join(', ');
        }
        return values;
    };

    return isDirectProvider && (isAdvancedMode || learningActivityID) ? (
        <FormSection id="advanced-settings" header={formatMessage(messages.advancedSettingsHeader)}>
            <ColumnLayout>
                <div data-awsui-column-layout-root="true">
                    <FormField
                        stretch
                        description={formatMessage(messages.grimsbyActivityIdDescription)}
                        label={formatMessage(messages.grimsbyActivityIdLabel)}
                    >
                        <div className="ClassForm__learningActivityID">
                            <Input
                                value={learningActivityID}
                                invalid={!!fieldsInvalid.learningActivityID}
                                onInput={e => {
                                    handleFormValueChange({
                                        value: e.detail.value,
                                        setData: setClassData,
                                        keyPath: 'learningActivityID',
                                    });
                                }}
                                id="ClassForm__learningActivityID"
                                onKeypress={handleKeyboardSubmit}
                            ></Input>
                            <FieldErrors
                                fieldsInvalid={fieldsInvalid}
                                property="learningActivityID"
                                valueFormatter={valueFormatter}
                            />
                        </div>
                    </FormField>
                    <FormField>
                        <Checkbox
                            checked={checked}
                            label={formatMessage(messages.locationSourceLabel)}
                            onChange={({ detail }) => {
                                setChecked(detail.checked);
                                handleFormValueChange({
                                    value: detail.checked
                                        ? LOCATION_SOURCES.LADS
                                        : LOCATION_SOURCES.DEFAULT,
                                    setData: setClassData,
                                    keyPath: 'source',
                                });
                            }}
                            id="ClassForm__source"
                        ></Checkbox>
                    </FormField>
                </div>
            </ColumnLayout>
        </FormSection>
    ) : null;
};

export default AdvancedSettings;
